import { PieChartComponent } from './pie-chart.component';

export default angular
  .module('sfMobile.components.pie-chart', [])
  .component('sfPieChart', PieChartComponent).name;
